import {
  ExternalFeatureLayerName,
  ExternalFeatureLayerServer,
} from './mapping.types';

export const getExternalFeatureLayerId = (
  featureLayer: ExternalFeatureLayerServer,
): ExternalFeatureLayerName => {
  return `organization_${featureLayer.organizationId}_${featureLayer.shortName}` as ExternalFeatureLayerName;
};
